import React, { useState, useEffect } from 'react'
import { Grid, TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import Card from './SubscriberCard'

const styles = theme => ({
  container: {
    width: '100%'
  },
  search: {
    padding: theme.spacing.unit,
    width: 250
  }
})

const SEARCH_DELAY = 800

const Subscribers = ({ classes, subscribers, isLoading, fetchSubscribers, removeSubscriber }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (subscribers === undefined && !isLoading) {
      fetchSubscribers()
    }
  })

  // stores the currently applied search input
  const [searchInput, setSearchInput] = useState([''])
  // holds the reference to setTimeout function for updating search results
  const [timer, setTimer] = useState()

  /* handler for input change of search bar
  the views are updated automatically after short delay,
  once user stops typing */
  const handleSearchChange = event => {
    const newInput = event.target.value.trim().split(' ')
    clearTimeout(timer)
    setTimer(setTimeout(
      () => setSearchInput(newInput),
      SEARCH_DELAY
    ))
  }

  return (
    <div className={classes.container}>
      <TextField
        className={classes.search}
        label={t('Cabinet:search')}
        placeholder={t('Cabinet:search names and interests')}
        margin='normal'
        onChange={handleSearchChange}
      />

      { subscribers && (
        <Grid container>
          {
            subscribers
              .filter(({ name, interests }) =>
                searchInput.some(s => interests.map(i => i.name).includes(s) || name.includes(s))
              )
              .map(({ id, name, interests, avatarBytes, description }) => (
                <Card
                  key={id}
                  name={name}
                  image={avatarBytes}
                  interests={interests.map(i => ' ' + i.name)}
                  description={description}
                  removeSubscriber={() => (removeSubscriber(id))}
                />
              ))
          }
        </Grid>
      )}
    </div>
  )
}

export default withStyles(styles)(Subscribers)
